import { useEffect, useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, inr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function ClosureCheck({ projectId, onClose, label = "Move to Closure", disabled }) {
  const { isAdmin } = useAuth();
  const [chk, setChk] = useState(null);
  useEffect(() => {
    setChk(null);
    api.get(`/projects/${projectId}/closure-check`).then((r) => setChk(r.data)).catch(() => setChk({ ok: false, checks: [], unpaid_bills: [] }));
  }, [projectId]);
  if (!chk) return <div data-testid="closure-check-loading" className="text-xs text-zinc-400">Checking closure checklist…</div>;
  return (
    <div data-testid="closure-checklist" className="w-full rounded-lg border border-zinc-200 bg-zinc-50 p-3 text-sm">
      <div className="mb-2 text-[11px] font-semibold uppercase tracking-wider text-zinc-500">Closure checklist</div>
      {chk.checks.map((c) => (
        <div key={c.key} data-testid={`closure-check-${c.key}`} className="flex items-start gap-2 py-1">
          {c.ok ? <CheckCircle2 className="mt-0.5 h-4 w-4 text-emerald-600" /> : <XCircle className="mt-0.5 h-4 w-4 text-rose-600" />}
          <div><div className="font-medium text-zinc-800">{c.label}</div><div className="text-xs text-zinc-500">{c.detail}</div></div>
        </div>
      ))}
      {chk.unpaid_bills.length > 0 && (
        <ul data-testid="closure-unpaid-bills" className="ml-6 mt-1 space-y-0.5 text-xs text-zinc-600">
          {chk.unpaid_bills.slice(0, 6).map((b) => <li key={b.id}>{b.company} · #{b.bill_number} · {inr(b.amount)} · {b.approval_status}</li>)}
          {chk.unpaid_bills.length > 6 && <li>+{chk.unpaid_bills.length - 6} more</li>}
        </ul>
      )}
      <div className="mt-3 flex flex-wrap gap-2">
        <Button data-testid="closure-confirm-button" disabled={!chk.ok || disabled} onClick={() => onClose(false)}>{label}</Button>
        {!chk.ok && isAdmin && <Button data-testid="closure-override-button" variant="outline" className="text-rose-700" disabled={disabled}
          onClick={() => window.confirm("Close this project even though the checklist is not complete?") && onClose(true)}>Close anyway (admin)</Button>}
      </div>
      {!chk.ok && <div className="mt-2 text-xs text-zinc-500">Pay all vendor bills and record the full client payment to close this project.</div>}
    </div>
  );
}
